import h from 'react-hyperscript';

const TabFocus = (props) => {
  return (
    h('div', {
      className: `tab-focus ${props.classes}`,
      tabIndex: 0,
      ...props,

    }, props.children)
  );
};

export default TabFocus;
